import React, { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from "react";
import chiusureJson from "../assets/chiusure.json";
import { NullableString } from "../../../../core/common_types";
import { Chiusura } from "../../../../models/pergola_configuration";

type ChiusureContextData = {
  getChiusuraName: (code: string | null | undefined) => string;
  getChiusuraPrice: (code: string | null | undefined) => number | null;
  getChiusuraImgPreview: (code: NullableString) => Promise<HTMLImageElement | undefined>;
  list: Chiusura[];
};

const ChiusureContext = createContext<ChiusureContextData | null>(null);

const ChiusureProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [chiusureData, setChiusureData] = useState<Chiusura[]>([]);

  useEffect(() => {
    setChiusureData(chiusureJson);
  }, []);

  const getChiusuraName = (code: string | null | undefined) => {
    if (!code) return "";
    const found = chiusureData.find(c => c.code === code);
    return found ? found.name : code ?? "";
  };

  const getChiusuraPrice = (code: string | null | undefined) => {
    if (!code) return null;
    const found = chiusureData.find(c => c.code === code);
    return found ? found.price : null;
  };

  const getChiusuraImgPreview = (code: NullableString): Promise<HTMLImageElement | undefined> => {
    return new Promise(resolve => {
      if (!code) {
        resolve(undefined);
        return;
      }
      const chiusura = chiusureData.find(c => c.code === code);
      if (chiusura && chiusura.img) {
        const img = new Image(800, 800);
        img.onload = () => {
          resolve(img);
        };
        img.src = chiusura.img;
        img.crossOrigin = "anonymous";
        img.referrerPolicy = "origin";
        return;
      }
      resolve(undefined);
    });
  };

  return (
    <ChiusureContext.Provider value={{ getChiusuraName, getChiusuraPrice, getChiusuraImgPreview, list: chiusureData }}>
      {children}
    </ChiusureContext.Provider>
  );
};

export default ChiusureProvider;

export const useChiusure = () => useContext(ChiusureContext);
